var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewFactory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.751,
    height: 41.78,
    viewBox: "0 0 52.751 41.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3026.249-10857.068v-2.315h1.579v-14.7l11.28-6.41.7-18.354h9.6l1.039,20.787,4.422-2.488.7-18.3h9.6l1.038,20.779,10.985-6.15v24.836H3079v2.315Zm48.634-2.315v-1.011h-27.036v1.011Zm-29.342,0v-4.9h-10.632v4.9Zm-12.938,0v-1.011h-2.469v1.011Zm42.28-3.325v-17.569l-15.788,8.841v-8.835l-15.711,8.84v-8.831l-13.25,7.529v10.025h2.469v-3.893h15.244v3.893Zm-13.481-12.672,2.557-1.431-.63-12.607h-5.814l-.288,7.543,4.175-2.35Zm-15.711,0,2.51-1.414-.631-12.621h-5.813l-.29,7.585,4.224-2.4Zm17.522-16.351-.057-1.132h-5.51l-.043,1.132Zm-15.758,0-.057-1.132h-5.51l-.043,1.132Zm15.586-3.448-.067-1.35h-5.187l-.052,1.35Zm-15.758,0-.068-1.35h-5.187l-.052,1.35Zm22.665,31.054v-4.408h2.306v4.408Zm-3.715,0v-4.408h2.306v4.408Zm-3.715,0v-4.408h2.306v4.408Zm-3.716,0v-4.408h2.306v4.408Zm-3.715,0v-4.408h2.306v4.408Zm-3.715,0v-4.408h2.306v4.408Zm-18.693-3.4v-2.315h15.172v2.315Z",
    transform: "translate(-3026.249 10898.849)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFactory);
export default __webpack_public_path__ + "static/media/new_factory.ee742ef7.svg";
export { ForwardRef as ReactComponent };